const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the user editor directive to manage edits on user objects
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('userEditor', ['Application', 'Authorization', 'AdminUsers', 'AccessHelper', 'Partners', 'Users', 'Categories', '$q', '$translate', '$timeout', function(Application, Authorization, AdminUsers, AccessHelper, Partners, Users, Categories, $q, $translate, $timeout) {
    return {
      restrict: 'E',
      scope: {
        referenceUser: '=',
        isTab: '=?',
        currentTab: '=?',
        targetTab: '=?'
      },
      replace: true,
      template: require('../../templates/directives/user-editor.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.unavailableChecked = true;
          self.showUserid = Authorization.getAuthToken() && Authorization.getAuthToken().company && Authorization.getAuthToken().company.show_userid || false;
          self.showDeparture = false;

          self.flags = Application.features.flags();

          self.company = Authorization.getAuthToken() && Authorization.getAuthToken().company || {};

          self.datepickerFormat = Application.dateFormatting.getStandardFormat();
          self.momentFormat = Application.dateFormatting.getStandardMomentFormat();
          self.dateFromString = function(string) {
            return moment(string, self.momentFormat).toDate();
          };

          self.allowance = {
            add: AccessHelper.isAllowed(['admin', 'users', 'add'], null, ['admin']),
            edit: AccessHelper.isAllowed(['admin', 'users', 'edit'], null, ['admin']),
            view: AccessHelper.isAllowed(['admin', 'users', 'view'], null, ['admin']),
            view_restricted: AccessHelper.isAllowed(['admin', 'users', 'restricted_access'], null, ['admin', 'creator', 'manager']),
            suspend: AccessHelper.isAllowed(['admin', 'users', 'suspend'], null, ['admin']),
            password_reset: AccessHelper.isAllowed(['admin', 'users', 'password_reset'], null, ['admin']),
            admin_set: AccessHelper.isAllowed(['admin', 'users', 'admin_set'], null, ['admin']),
            creator_set: AccessHelper.isAllowed(['admin', 'users', 'creator_set'], null, ['admin', 'creator', 'manager']),
            profile_set: AccessHelper.isAllowed(['admin', 'users', 'profile_set'], null, ['admin', 'creator', 'manager']),
            manager_set: AccessHelper.isAllowed(['admin', 'users', 'manager_set'], null, ['admin', 'creator', 'manager']),
            purchaser_set: !!Application.features.flags().enable_ecommerce,
            buddy_set: AccessHelper.isAllowed(['admin', 'users', 'buddy_set'], null, ['admin', 'creator', 'manager']),
            external_users: AccessHelper.isAllowed(['admin', 'users', 'external_users'], null, ['admin', 'creator', 'manager']),
          };

          if (!self.allowance.edit) {
            Application.navigation.goTo('/explore');
            return;
          }

          var restrictedGroup = Application.access.profile && Application.access.profile.permissions && Application.access.profile.permissions.admin && Application.access.profile.permissions.admin.users && Application.access.profile.permissions.admin.users.user_group || {};
          var types = ['departments', 'locations', 'teams', 'org_levels', 'grades'];
          self.restricted = self.allowance.view_restricted;
          self.restrictions = {};
          self.allCategories = {};

          types.forEach(function(type) {
            self.restrictions[type] = !!self.restricted;
            self.allCategories[type] = [];
            if (!restrictedGroup[type] || !restrictedGroup[type].length) {
              self.restrictions[type] = false;
            }
          });

          $scope.referenceUser = {};
          self.currentMainTab = 'general';
          self.loading = false;
          self.topLocations = [];
          self.topDepartments = [];
          self.originalTeams = [];
          self.originalGrades = [{name: '', value: 'clear'}];
          self.originalOrgLevels = [{name: '', value: 'clear'}];
          self.directory = {};
          self.locationOptions = {};
          self.locationSelections = {};
          self.departmentOptions = {};
          self.departmentSelections = {};
          self.orgLevelSelection;
          self.gradeSelection;
          self.newTeamSelection;
          self.teamsSelections = [];
          self.showExtraOptions = false;
          self.languages = Application.languages.getAvailable();
          self.partners = [];
          self.editSaved = true;
          self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
          self.denied = false;
          self.signin_userid = Application.features.flags().signin_userid;
          self.signin_userid_copy = {field_name: 'User-ID'};
          if (self.signin_userid && Authorization.getAuthToken().company.signin_userid_copy) {
            self.signin_userid_copy = Authorization.getAuthToken().company.signin_userid_copy;
          }

          var locationChange = $scope.$on('$locationChangeStart', function(event) {
            if (self.editSaved) {
              // Allow the route change to progress
              self.denied = true;
              return;
            }

            // Halt the route change and question the action
            self.navigationPath = {};
            self.navigationPath.targetPath = Application.navigation.getPath();
            self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
            self.navigationPath.targetHash = Application.navigation.getHash();
            event.preventDefault();
            self.showDeparture = true;
            if($scope.isTab){
              $scope.currentTab = $scope.targetTab;
            }
            self.onLocationChange = function() {
              locationChange();
            };
          });

          // ---- Role and Manager related
          self.roleManager = {
            manager_info: {},
            manager_state: null,
            edit_manager: false,
            manager_choice: false,
            chooseRole: function(index) {
              var value = self.roles[index].value;
              if (value !== 'user' && self.user.partner?.length) {
                Application.messaging.addMessage({ type: 'error', duration: 5, text: self.translations['partners.userRole.message'] });
                self.chosenValue = 'user';
                return;
              }
              if (value === 'admin' && !self.allowance.admin_set) {
                return;
              }
              if (value === 'creator' && !self.allowance.creator_set) {
                return;
              }
              if (value === 'external' && !self.allowance.external_users) {
                return;
              }
              self.user.role = value;
              if (self.user.role !== 'user') {
                self.user.is_collaborator = false;
              }
              self.unavailableChecked = false;
            },
            changeManager: function(type) {
              self.user.is_manager = type === 'yes' ? true : false;
            },
            inputClick: function(index, manager) {
              var input;
              if (index || index === 0) {
                input = document.getElementById('role-' + index);
              } else if (manager) {
                input = document.getElementById(manager);
              }
              setTimeout(function() {
                input.click();
              }, 1);
            },
            stopProp: function(evt) {
              evt.stopPropagation();
            },
            setInitialRoleManager: function(user) {
              for (var i = 0; i < self.roles.length; i++) {
                if (user.role === self.roles[i].value) {
                  this.inputClick(i);
                  break;
                }
              }
              ;
              if (user.is_manager) {
                this.inputClick(null, 'yes-manager');
              } else {
                this.inputClick(null, 'no-manager');
              }
            },
            findManger: function() {
              if (!self.user || !self.user.manager_email) {
                self.roleManager.manager_state = null;
                return;
              }
              if (self.user.manager_email === this.manager_info.email) {
                return;
              }

              // Ok to use unprotected find here
              Users.find({email: self.user.manager_email, fields: 'first_name,last_name,full_name,email,image'}).$promise
              .then(function(users) {
                if (!users.length) {
                  self.roleManager.manager_state = 'email';
                  self.roleManager.manager_info.email === self.user.manager_email;
                  return;
                }
                self.roleManager.manager_info = users[0];
                self.roleManager.manager_state = 'full';
              });
            },
            newManager: function() {
              this.manager_choice = true;
              this.edit_manager = false;
              self.user.manager_email = '';
              self.roleManager.findManger();
            },
            removeManager: function() {
              this.updateManager();
              this.edit_manager = false;
            },
            updateManager: function(email) {
              var maintain = self.editSaved ? true : false;
              email = email ? email : '';
              Users.update({subresource: self.user._id, fields: 'first_name,last_name,email,userid,manager_email'}, {manager_email: email}).$promise
                  .then(function(user) {
                    self.user.manager_email = email;
                    self.roleManager.findManger();
                    Application.messaging.addMessage({type: 'success', text: self.translations['userEditor.manager_has_been_updated'], duration: 5});
                    setTimeout(function() {
                      self.editSaved = maintain;
                    }, 50);
                  });
            }
          };

          self.purchaser = {
            changePurchaser: function(type) {
              self.user.is_purchaser = type;
            },
            setInitialPurchaser: function(isPurchaser) {
              if (isPurchaser) {
                this.inputClick('yes-purchaser');
              } else {
                this.inputClick('no-purchaser');
              }
            },
            stopProp: function(evt) {
              evt.stopPropagation();
            },
            inputClick: function(id) {
              input = document.getElementById(id);
              setTimeout(function() {
                input.click();
              }, 1);
            }
          };

          // ---- End Role related

          self.buddyManager = {
            buddy_info: {},
            buddy_state: null,
            edit_buddy: false,
            buddy_choice: false,
            findBuddy: function() {
              if (!self.user || !self.user.buddy_email) {
                self.buddyManager.buddy_state = null;
                return;
              }
              if (self.user.buddy_email === this.buddy_info.email) {
                return;
              }

              Users.find({email: self.user.buddy_email, fields: 'first_name,last_name,full_name,email,image'}).$promise
                  .then(function(users) {
                    if (!users.length) {
                      self.buddyManager.buddy_state = 'email';
                      self.buddyManager.buddy_info.email = self.user.buddy_email;
                      return;
                    }
                    self.buddyManager.buddy_info = users[0];
                    self.buddyManager.buddy_state = 'full';
                  });
            },
            newBuddy: function() {
              this.buddy_choice = true;
              this.edit_buddy = false;
              self.user.buddy_email = '';
              self.buddyManager.findBuddy();
            },
            removeBuddy: function() {
              this.updateBuddy();
              this.edit_buddy = false;
            },
            updateBuddy: function(email) {
              var maintain = self.editSaved ? true : false;
              email = email ? email : '';
              Users.update({subresource: self.user._id, fields: 'first_name,last_name,email,userid,buddy_email'}, {buddy_email: email}).$promise
              .then(function(user) {
                self.user.buddy_email = email;
                self.buddyManager.findBuddy();
                Application.messaging.addMessage({type: 'success', text: self.translations['userEditor.buddy_has_been_updated'], duration: 5});
                setTimeout(function() {
                  self.editSaved = maintain;
                }, 50);
              });
            }
          };

          self.save = function() {
            self.loading = true;

            if (self.hired !== self.originalHired) {
              self.user.hired = self.dateFromString(self.hired);
            }

            self.user.email = self.user.email.toLowerCase();
            Users.update({subresource: self.user._id, fields: 'first_name,last_name,email,userid,job_title,job_type,role,office_location,language,image,department,last_login,notes,hired,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,is_collaborator,is_manager,manager_email,buddy_email,address,region,distributor,group,access_profile,groups,managing_groups,manager_configuration,metadata,partner,partner_role,is_purchaser'}, self.user, function(user) {
              user.formattedLastLogin = moment(user.last_login).format("MMM Do YY");
              self.originalUser = JSON.parse(JSON.stringify(user));
              self.user = user;
              $scope.referenceUser.is_manager = user.is_manager;
              $scope.referenceUser.is_collaborator = user.is_collaborator;
              $scope.referenceUser.email = user.email;
              $scope.referenceUser.userid = user.userid;
              $scope.referenceUser.full_name = user.full_name;
              $scope.referenceUser._id = user._id;
              self.roleManager.findManger();
              self.buddyManager.findBuddy();
              Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.user_saved'], duration: 5});
              setTimeout(function() {
                self.editSaved = true;
              }, 100);
              self.loading = false;
            }, function(error) {
              var err = error;
              let errorMessage = err.data.errors[0]?.code || self.translations['modules.notifications.user_couldNotBeSaved'];
              if (err.data.error?.codeName === "DuplicateKey") {
                Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.user_emailTaken'], duration: 5});
              } else {
                Application.messaging.addMessage({type: 'error', text: errorMessage, duration: 5});
              }
              self.loading = false;
            });
          };

          var setCategories = function(type) {
            var link = type === 'location' ? 'linked_locations' : 'linked_departments';
            var selection = type === 'location' ? 'locationSelections' : 'departmentSelections';
            var option = type === 'location' ? 'locationOptions' : 'departmentOptions';
            var items = {};
            var parent;
            var papa;

            if (!self.user[link] || !self.user[link].length) {
              return;
            }
            var selected = self.user[link][0];
            if (!self.directory[selected]) {
              return;
            }
            selected = self.directory[selected];
            items[selected.level] = selected._id;
            if (selected.parent && self.directory[selected.parent]) {
              parent = self.directory[selected.parent];
              items[parent.level] = parent._id;
            }
            if (parent && parent.parent && self.directory[parent.parent]) {
              papa = self.directory[parent.parent];
              items[papa.level] = papa._id;
            }
            if (items[1]) {
              self[selection].top = items[1];
              setChildOptions(items[1], 'children', self[option]);
              if (items[2]) {
                self[selection].child = items[2];
                setChildOptions(items[2], 'grandChildren', self[option]);
                if (items[3]) {
                  self[selection].grandChild = items[3];
                }
              }
            }
          };

          self.setOrgLevel = function(id) {
            if (id === 'clear') {
              self.user.linked_org_level = null;
              self.orgLevelSelection = "";
              return;
            }
            if (id && self.directory[id]) {
              self.user.linked_org_level = id;
              self.orgLevelSelection = id;
              return;
            }
          };

          self.setGrade = function(id) {
            if (id === 'clear') {
              self.user.linked_grade = null;
              self.gradeSelection = "";
              return;
            }
            if (id && self.directory[id]) {
              self.user.linked_grade = id;
              self.gradeSelection = id;
              return;
            }
          };

          self.setTeams = function() {
            self.teamsSelections = [];
            if (!self.user.linked_teams || !self.user.linked_teams.length) {
              return;
            }
            self.user.linked_teams.forEach(function(teamId) {
              if (teamId && self.directory[teamId]) {
                self.teamsSelections.push(teamId);
              }
            });
          };

          self.removeTeam = function(id) {
            var index = self.user.linked_teams.indexOf(id);
            if (!index && index !== 0) {
              return;
            }
            self.user.linked_teams.splice(index, 1);
            self.setTeams();
          };

          self.avatar = {
            image: '',
            active: false,
            loading: false,
            percent: null,
            image_name: '',
            modifiedLink: '',
            old: '',
            crop: function(link) {
              self.avatar.saveImage(link);
            },
            cancelCrop: function() {
              self.avatar.image = '';
              self.avatar.percent = null;
              self.avatar.loading = false;
              self.avatar.active = false;
              self.avatar.apply = false;
            },
            remove: function() {
              self.avatar.old = self.user.image;
              self.avatar.saveImage('');
            },
            progress: function() {
              if (this.percent === null) {
                return 0 + '';
              }
              return this.percent - 100 + '%';
            },
            saveImage: function(image) {
              var body = {image: image};
              Users.update({subresource: self.user._id, fields: 'first_name,last_name,email,image'}, body).$promise
                  .then(function(user) {
                    self.user.image = user.image;
                    Application.messaging.addMessage({type: 'success', duration: 3, text: self.translations['userEditor.image_saved']});
                    self.avatar.cancelCrop();
                  }).catch(function(error) {
              });
            }
          };

          $scope.$watch('editor.avatar.image', function(newVal, oldVal) {
            if (!newVal || newVal === oldVal) {
              return;
            }

            self.avatar.active = true;
          });

          self.initialize = function() {
            var routeParameters = Application.navigation.getRouteParameters();
            if (!routeParameters.id) {
              Application.navigation.goTo('overview/users');
              return;
            }
            if (Authorization.getAuthToken().user._id.toString() !== routeParameters.id.toString() && Authorization.getAuthToken().user.role !== 'admin') {
              Application.navigation.goTo('/explore');
            }
            var usersPromise = AdminUsers.get({subresource: routeParameters.id, fields: 'first_name,last_name,email,userid,job_title,job_type,role,language,image,department,last_login,createdAt,notes,hired,linked_locations,linked_departments,is_collaborator,is_manager,manager_email,buddy_email,linked_teams,linked_org_level,linked_grade,address,country,distributor,region,group,access_profile,groups,managing_groups,manager_configuration,provisioning_status,metadata,partner,partner_role,is_purchaser'}).$promise;
            var categoriesPromise = Categories.find({fields: 'name,level,children,parent,location,department,team,org_level,category,grade', category: '$ne,true'}).$promise;
            var partnersPromise = Partners.find({perPage: 9999999}).$promise;
            $q.all([usersPromise, categoriesPromise, partnersPromise]).then(function(results) {
              var user = results[0];
              var cats = results[1];
              var partners = results[2];

              // Exclude inactive partners
              partners = partners.filter(partner => partner.active);

              if (!user || !user._id) {
                Application.navigation.goTo('/explore');
                return;
              }

              if (!user.groups) {
                user.groups = [];
              }

              user.formattedLastLogin = moment(user.last_login).format("MMM Do YY");
              self.user = user;
              if (!self.user.manager_configuration) {
                self.user.manager_configuration = {
                  disable_assignments: false,
                  allow_user_creation: false,
                  segmentation_required: [],
                  segmentation_subset: [],
                  hide_options: [],
                  allow_user_edit: false,
                  restricted_user_edit: false,
                  restricted_editable_fields: [],
                  allow_adding_group_manager: false,
                  disable_assignment_completion: false,
                  disable_assignment_removal: false,
                  hide_non_managing_groups: false,
                  allow_password_reset: false
                };
              }

              if (!self.allowance.creator_set && self.user.role === 'creator') {
                self.showUnavailableRole = self.translations['manage.users.creator'];
              }
              if (!self.allowance.admin_set && self.user.role === 'admin') {
                self.showUnavailableRole = self.translations['manage.users.administrator'];
              }
              if (Authorization.getAuthToken().company.external_users && !self.allowance.external_users && self.user.role === 'external') {
                self.showUnavailableRole = self.translations['manage.users.external'];
              }

              self.user.linked_teams = self.user.linked_teams || [];
              $scope.referenceUser.is_manager = user.is_manager;
              $scope.referenceUser.is_collaborator = user.is_collaborator;
              $scope.referenceUser.email = user.email;
              $scope.referenceUser.userid = user.userid;
              $scope.referenceUser.full_name = user.full_name;
              $scope.referenceUser._id = user._id;
              self.roleManager.setInitialRoleManager(self.user);
              self.purchaser.setInitialPurchaser(self.user.is_purchaser);
              self.roleManager.findManger();
              self.buddyManager.findBuddy();
              self.originalUser = JSON.parse(JSON.stringify(user));
              if (!self.user.job_type) {
                self.user.job_type = 'SV';
              }

              if (!self.user.language) {
                self.user.language = self.languages[0].value;
              }
              const partnersDropdown = partners.map(part => {
                return {
                  value: part._id,
                  name: part.name.toString().trim(),
                }
              });
              partnersDropdown.sort((a, b) => { return a.name < b.name; });
              self.partners = [{name: "Select Extend Account", value: ""}, ...partnersDropdown];
              self.user.partner = self.user.partner || "";
              self.user.partner_role = self.user.partner_role || 'user';

              self.newHire = false;
              if (self.user.hired) {
                const newDate = moment.utc().subtract(90, 'days');
                const hiredOn = moment.utc(self.user.hired);
                if (moment.max(newDate, hiredOn).format('MM/DD/YY') === hiredOn.format('MM/DD/YY')) {
                  self.newHire = true;
                }
                self.hired = hiredOn.format('MM/DD/YY') !== '01/01/70' ? hiredOn.local().format(self.momentFormat) : '';
                self.originalHired = self.hired.slice(0);
              }
              self.inactive = false;
              if (self.user.last_login) {
                var newInactive = moment().subtract(30, 'days');
                var ll = moment(new Date(self.user.last_login));
                if (moment.max(newInactive, ll).format('MM/DD/YY') === newInactive.format('MM/DD/YY')) {
                  self.inactive = true;
                }
              }
              angular.forEach(cats, function(cat) {
                cat.value = cat._id;
                if (cat.location) {
                  if (cat.level === 1) {
                    self.topLocations.push(cat);
                  }
                  self.allCategories.locations.push(cat);
                }
                if (cat.department) {
                  if (cat.level === 1) {
                    self.topDepartments.push(cat);
                  }
                  self.allCategories.departments.push(cat);
                }
                if (cat.team) {
                  self.originalTeams.push(cat);
                  self.allCategories.teams.push(cat);
                }
                if (cat.org_level) {
                  self.originalOrgLevels.push(cat);
                  self.allCategories.org_levels.push(cat);
                }
                if (cat.grade) {
                  self.originalGrades.push(cat);
                  self.allCategories.grades.push(cat);
                }
                self.directory[cat._id] = cat;
              });
              setCategories('location');
              setCategories('department');
              self.setTeams();
              self.setOrgLevel(self.user.linked_org_level);
              self.setGrade(self.user.linked_grade);
              self.lastLogin = self.user.last_login ? moment(new Date(self.user.last_login)).format('MMMM Do YYYY') : '----';
              self.created = self.user.createdAt ? moment(new Date(self.user.createdAt)).format('MMMM Do YYYY') : '----';
              self.startEditWatch();
            });
          };

          var setChildOptions = function(id, type, options) {
            options.grandChildren = [];
            if (type === 'children') {
              options.children = [];
            }
            var items = [];
            if (self.directory[id] && self.directory[id].children) {
              angular.forEach(self.directory[id].children, function(item) {
                if (self.directory[item]) {
                  items.push(self.directory[item]);
                }
              });
              options[type] = items;
            }
          };

          $scope.$watch('editor.orgLevelSelection', function(newVal, oldVal) {
            if (newVal && (self.directory[newVal] || newVal === 'clear')) {
              if (self.user.linked_org_level === newVal) {
                return;
              }
              self.setOrgLevel(newVal);
            }
          }, true);

          $scope.$watch('editor.gradeSelection', function(newVal, oldVal) {
            if (newVal && (self.directory[newVal] || newVal === 'clear')) {
              if (self.user.linked_grade === newVal) {
                return;
              }
              self.setGrade(newVal);
            }
          }, true);

          $scope.$watch('editor.newTeamSelection', function(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
              if (self.user.linked_teams.indexOf(newVal) !== -1) {
                self.newTeamSelection = null;
                return;
              }
              self.user.linked_teams.push(newVal);
              self.newTeamSelection = null;
              self.setTeams();
            }
          }, true);

          $scope.$watch('editor.locationSelections', function(newVal, oldVal) {
            if (newVal.grandChild && newVal.grandChild !== oldVal.grandChild) {
              self.user.linked_locations = [newVal.grandChild];
              return;
            }
            if (newVal.child && newVal.child !== oldVal.child) {
              self.user.linked_locations = [newVal.child];
              setChildOptions(newVal.child, 'grandChildren', self.locationOptions);
              self.locationSelections.grandChild = null;
              return;
            }
            if (newVal.top && newVal.top !== oldVal.top) {
              self.user.linked_locations = [newVal.top];
              setChildOptions(newVal.top, 'children', self.locationOptions);
              self.locationSelections.grandChild = null;
              self.locationSelections.child = null;
              return;
            }
          }, true);

          $scope.$watch('editor.departmentSelections', function(newVal, oldVal) {
            if (newVal.grandChild && newVal.grandChild !== oldVal.grandChild) {
              self.user.linked_departments = [newVal.grandChild];
              return;
            }
            if (newVal.child && newVal.child !== oldVal.child) {
              self.user.linked_departments = [newVal.child];
              setChildOptions(newVal.child, 'grandChildren', self.departmentOptions);
              self.departmentSelections.grandChild = null;
              return;
            }
            if (newVal.top && newVal.top !== oldVal.top) {
              self.user.linked_departments = [newVal.top];
              setChildOptions(newVal.top, 'children', self.departmentOptions);
              self.departmentSelections.grandChild = null;
              self.departmentSelections.child = null;
              return;
            }
          }, true);

          $scope.$watch('editor.user.partner', function(newVal, oldVal) {
            // Just to keep a user from having no partner and a principal role
            if (newVal === oldVal) {
              return;
            }
             if (newVal?.length && self.user.role !== 'user') {
              self.user.partner = oldVal;
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['partners.userRole.message']});
            }
            if (newVal === '') {
              self.user.partner_role = 'user'
            } else {
              // Everything about this is terrible, but it matches the way we're fixing 
              // radio button usage elsewhere on this form.
              $timeout(function() {
                document.getElementById('role-0').click();
              }, 50);
            }
          }, true);

          self.startEditWatch = function() {
            $scope.$watch('editor.user', function(newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              if (newVal.image !== oldVal.image) {
                return;
              }
              self.editSaved = false;
            }, true);
            $scope.$watch('editor.hired', function(newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              self.editSaved = false;
            });
          };

          var langTranslations = self.languages.map(function(item) {
            return item.name;
          });
          $translate([
            'modules.notifications.invalidUrl',
            'modules.notifications.user_couldNotBeSaved',
            'modules.notifications.user_saved',
            'manage.users.creator',
            'manage.users.external',
            'manage.users.administrator',
            'manage.users.user',
            'manage.users.department',
            'manage.users.location',
            'manage.users.selectALocation',
            'manage.partner.principal',
            'userEditor.manager_has_been_updated',
            'userEditor.image_saved',
            'userEditor.buddy_has_been_updated',
            'modules.notifications.user_emailTaken',
            'partners.userRole.message'
          ].concat(langTranslations)).then(function(data) {
            self.translations = data;
            self.roles = [
              {name: self.translations['manage.users.user'], value: 'user', disabled: false}
            ];
            if (self.allowance.creator_set) {
              self.roles.push({name: self.translations['manage.users.creator'], value: 'creator'});
            }
            if (self.allowance.admin_set) {
              self.roles.push({name: self.translations['manage.users.administrator'], value: 'admin'});
            }

            if (Authorization.getAuthToken().company.external_users && self.allowance.external_users) {
              self.roles.push({name: self.translations['manage.users.external'], value: 'external'});
            }

            self.partnerRoles = [
              {name: self.translations['manage.users.user'], value: 'user'},
              {name: self.translations['manage.partner.principal'], value: 'principal'}
            ]

            self.languages = self.languages.map(function(item) {
              if (data[item.name]) {
                item.name = data[item.name];
              }
              return item;
            });

            self.initialize();
          });
        }],
      controllerAs: 'editor'
    };
  }]);
